import React, { useState, useEffect } from 'react';
import './LinkedInEmbed.css';

const LinkedInEmbed = () => {
  const [currentLinkedInPost, setCurrentLinkedInPost] = useState(0);
  const [linkedInPaused, setLinkedInPaused] = useState(false);
  
  // LinkedIn embedded posts
  const linkedInPosts = [
    {
      id: 1,
      embedCode: '<iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7324125759076188160" height="733" width="780" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>'
    },
    {
      id: 2,
      embedCode: '<iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7321894251242442752" height="816" width="780" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>'
    },
    {
      id: 3,
      embedCode: '<iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:7321342486881177601" height="758" width="780" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>'
    }
  ];

  // Function to create HTML markup for LinkedIn embed
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent };
  };

  // Function to navigate to the next LinkedIn post
  const nextLinkedInPost = () => {
    setLinkedInPaused(true);
    setCurrentLinkedInPost(prev => 
      prev === linkedInPosts.length - 1 ? 0 : prev + 1
    );
    setTimeout(() => setLinkedInPaused(false), 8000); // Resume after 8 seconds
  };

  // Function to navigate to the previous LinkedIn post
  const prevLinkedInPost = () => {
    setLinkedInPaused(true);
    setCurrentLinkedInPost(prev => 
      prev === 0 ? linkedInPosts.length - 1 : prev - 1
    );
    setTimeout(() => setLinkedInPaused(false), 8000); // Resume after 8 seconds
  };

  // Auto-rotate LinkedIn posts
  useEffect(() => {
    if (linkedInPaused) return;
    
    const interval = setInterval(() => {
      setCurrentLinkedInPost(prev => 
        prev === linkedInPosts.length - 1 ? 0 : prev + 1
      );
    }, 12000); // Change LinkedIn post every 12 seconds
    
    return () => clearInterval(interval);
  }, [linkedInPaused, linkedInPosts.length]);

  return (
    <section className="linkedin-embed-section">
      <div className="linkedin-embed-container">
        <div className="section-header">
          <h2>Latest Updates</h2>
          <a 
            href="https://www.linkedin.com/in/amirali86" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="linkedin-profile-link"
          >
            Follow us on LinkedIn
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ marginLeft: '6px' }}>
              <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/>
            </svg>
          </a>
        </div>
        
        <div className="linkedin-carousel">
          <div className="linkedin-carousel-track">
            {linkedInPosts.map((post, index) => (
              <div 
                key={post.id}
                className={`linkedin-post-slide ${index === currentLinkedInPost ? 'active' : ''}`}
              >
                <div className="linkedin-post-container" dangerouslySetInnerHTML={createMarkup(post.embedCode)} />
              </div>
            ))}
          </div>
          <div className="linkedin-carousel-navigation">
            <button 
              onClick={prevLinkedInPost} 
              className="linkedin-nav-btn linkedin-prev-btn"
              aria-label="Previous LinkedIn post"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.5 19L8.5 12L15.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <div className="linkedin-indicators">
              {linkedInPosts.map((_, index) => (
                <button 
                  key={index} 
                  className={`linkedin-indicator ${index === currentLinkedInPost ? 'active' : ''}`}
                  onClick={() => {
                    setCurrentLinkedInPost(index);
                    setLinkedInPaused(true);
                    setTimeout(() => setLinkedInPaused(false), 8000);
                  }}
                  aria-label={`Go to LinkedIn post ${index + 1}`}
                ></button>
              ))}
            </div>
            <button 
              onClick={nextLinkedInPost} 
              className="linkedin-nav-btn linkedin-next-btn"
              aria-label="Next LinkedIn post"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.5 5L15.5 12L8.5 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LinkedInEmbed; 